<div mat-dialog-content>
  Please refresh this page to get the most recent status.
</div>
<br/><br/>
<div>
  Customer didn't receive the text?<br/><br/>
  <b>E-mail this link:</b>&nbsp;
  {{verifyLink}}{{referenceId}}
</div>

<br/><br/>
<div class="text-center">
  <button mat-flat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>CLOSE</button>
</div>

